import React from "react";
import { IMdaeAccordionProps } from "./index";
import "./index.scss";
import {
    DX_WIDGET_NAMES,
    configureMdaeWidgetOptionUpdaters,
  } from "../../mdae-framework";
import { Accordion } from "devextreme-react";
import { useDispatch } from "react-redux";
const MdaeAccordion: React.FC<IMdaeAccordionProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div>
      <Accordion
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_ACCORDION,
            e.component,
            dispatch
          );
        }}
      ></Accordion>
    </div>
  );
};
export default MdaeAccordion;
